import {
  DatabasesActionType,
  databasesStardogRequestDispatchers,
} from 'src/common/actions/databases/databasesActionCreators';
import {
  StudioStateGetter,
  StudioThunkDispatch,
} from 'src/common/actions/StudioAction';

export const requestDetailsForDatabase =
  (dbId: string) =>
  async (_: StudioThunkDispatch, getState: StudioStateGetter) => {
    const { features } = getState();
    const {
      isDatabaseListInfoSupported,
      isOverrideGraphQlDefaultLimitSupported,
      isUpdatedGetAllSupported,
      isVirtualTransparencySupported,
    } = features.stardog;

    const response =
      await databasesStardogRequestDispatchers.requestDetailsForDatabase({
        dbId,
        overrideGraphQlDefaultLimit: isOverrideGraphQlDefaultLimitSupported,
        stardogSupportsVirtualTransparency: isVirtualTransparencySupported,
        useGetAllMethod: isUpdatedGetAllSupported,
      });

    if (
      isDatabaseListInfoSupported &&
      response.type === DatabasesActionType.REQUEST_DETAILS_FOR_DATABASE_FAILURE
    ) {
      const infoResponse =
        await databasesStardogRequestDispatchers.requestDatabasesInfo({
          dbIds: [dbId],
          overrideGraphQlDefaultLimit: isOverrideGraphQlDefaultLimitSupported,
          stardogSupportsVirtualTransparency: isVirtualTransparencySupported,
        });

      return infoResponse;
    }

    return response;
  };
